// extracted by mini-css-extract-plugin
module.exports = {"group":"az_axb","actionCandidates":"az_bxb","carousel":"az_cxb","actionCandidatesTitle":"az_dxb","actionCandidatesContainer":"az_exb"};